// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAqzb7HlKBNRt4Om8pAAEOrwTcKf-BhB5Y',
    authDomain: 'tapit-research.firebaseapp.com',
    databaseURL: 'https://tapit-research.firebaseio.com',
    projectId: 'tapit-research',
    storageBucket: 'tapit-research.appspot.com',
    messagingSenderId: '474279840248'
  },
  auth0_domain: 'tapitsolutions.eu.auth0.com',
  auth0_client_id: '6efDI6FjU9E5i9iMgU60pp7CDaPpyuQS',
  auth0_audience: 'https://tapitsolutions.com',
  baseUrl: 'https://tapit-research.appspot.com:443/api',
  modeAnalyticsSecretKey: '5170f765aee4814e7ad4a226'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
